import React from "react";
import DashboardHeader from "./../../../../components/dashboardHeader/index";
import CustomContainer from "./../../../../components/container/CustomContainer";
import { useNavigate } from "react-router-dom";
import TimeTableCalendar from "./Calendar";

const EducationDbTimeTablePage = () => {
  const navigate = useNavigate();
  return (
    <DashboardHeader>
      <CustomContainer
        primaryHeading={"Time Table"}
        secondaryHeading={"View time table"}
        showBackButton={true}
        handleBack={() => navigate("/dashboard/education")}
        childrenProps={{
          minHeight: "100vh",
          padding:"16px 16px 0px 16px !important"
        }}
      >
        <TimeTableCalendar />
      </CustomContainer>
    </DashboardHeader>
  );
};

export default EducationDbTimeTablePage;
